<div
  [ngClass]="{
    'flex h-full w-full justify-center px-2 align-middle': true,
    'justify-end gap-4': buttonData.length > 1,
  }">
  @for (button of buttonData; track button.icon) {
    <ng-container>
      @if (button.hide !== true) {
        <div
          class="button-container flex items-center"
          [ngClass]="{ 'grow basis-0': button.shape !== ButtonShape.ROUNDED }"
          [matTooltip]="button.tooltip ? (button.tooltip! | translate) : null">
          <app-button
            class="grow"
            (click)="button.action(params.data)"
            [disabled]="button.disabled"
            [icon]="button.icon"
            [style]="button.style"
            [shape]="button.shape"
            [color]="button.color"
            [class]="button.class ?? ''"
            [size]="button.size ?? ButtonSize.SM"
            [attr.aria-label]="'Action button ' + button.icon">
            {{ getText(button) | translate }}
          </app-button>
        </div>
      }
    </ng-container>
  }
</div>
